import _ from 'underscore';
import { RANGES, getDateRanges } from '@bingads-webui/date-ranges';

const dateRangeMapping = {
  Yesterday: RANGES.YESTERDAY,
  LastSevenDays: RANGES.LAST_SEVEN_DAYS,
  Today: RANGES.TODAY,
  LastThirtyDays: RANGES.LAST_THIRTY_DAYS,
  LastFourteenDays: RANGES.LAST_FOURTEEN_DAYS,
  ThisMonth: RANGES.THIS_MONTH,
  LastMonth: RANGES.LAST_MONTH,
  LastThreeMonths: RANGES.LAST_THREE_MONTHS,
  LastSixMonths: RANGES.LAST_SIX_MONTHS,
  ThisYear: RANGES.THIS_YEAR,
  LastYear: RANGES.LAST_YEAR,
  AllTime: RANGES.ALL_TIME,
  ThisWeekFromSun: RANGES.THIS_WEEK_SUNDAY,
  ThisWeekFromMon: RANGES.THIS_WEEK_MONDAY,
  LastWeekStartingSun: RANGES.LAST_WEEK_SUNDAY,
  LastWeekStartingMon: RANGES.LAST_WEEK_MONDAY,
  LastBusinessWeek: null,
  LastFourWeeksStartingSun: null,
};

export function getStateDateRangePreset(DateRangePreset) {
  return DateRangePreset ? dateRangeMapping[DateRangePreset] : RANGES.CUSTOM;
}

const getRanges = _.once(() =>
  getDateRanges({
    today: new Date(),
    i18n: {
      getString: _.identity,
    },
  }));

export function convertDateRangePresetToRangeId(DateRangePreset) {
  const ranges = getRanges();
  const rangeKey = getStateDateRangePreset(DateRangePreset);

  return _.result(ranges[rangeKey], 'grain');
}


export const grains = {
  Yesterday: 1,
  LastSevenDays: 2,
  Today: 3,
  Custom: 4,
  LastThirtyDays: 5,
  LastFourteenDays: 6,
  ThisWeekFromSun: 7,
  ThisWeekFromMon: 8,
  LastWeekStartingSun: 9,
  ThisMonth: 10,
  LastMonth: 11,
  LastThreeMonths: 12,
  LastSixMonths: 13,
  LastWeekStartingMon: 14,
  LastBusinessWeek: 15,
  ThisYear: 20,
  LastYear: 21,
  AllTime: 22,
};

export function getSelectionDateRangePreset(statePreset, grain) {
  // For LastSevenDays, it's last7Days in CampaignUI, but lastSevenDays in HotelCenter
  // For LastFourteenDays, it's last14Days in CampaignUI, but lastFourteenDays in HotelCenter
  // The magic grain is same in both pages
  let preset;

  if (!_.isUndefined(statePreset)) {
    preset = _.findKey(dateRangeMapping, value => value === statePreset);
  }
  if (!preset) {
    preset = _.findKey(grains, value => value === grain);
  }
  return preset;
}
